"use client";

import { useLogoutWithCleanup } from "@/components/hooks/use-logout-with-cleanup";
import { pagesPath } from "@/utils/pages-path";
import { useRouter } from "next/navigation";
import { useCallback } from "react";

export function useLogout() {
  const router = useRouter();
  const { logout: logoutWithCleanup } = useLogoutWithCleanup();

  const logout = useCallback(async () => {
    await logoutWithCleanup();
    // memo: こうするとLoginFallbackに入るのを防げることが多い
    setTimeout(() => {
      router.push(pagesPath.employers.login.$url().path);
    }, 0);
  }, [router, logoutWithCleanup]);

  return logout;
}
